import "../CampusPlacementAndCareerDynamicPage/CampusPlacementCareerDynamicPage.scss"
import { useState } from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Header from "../../../../Shared-Component/Header/Header";
import Footer from "../../../../Shared-Component/Footer/Footer";
import CampusSlashTitle from "../../CampusTitles/CampusSlashTitle/CampusSlashTitle";
import { Link } from 'react-router-dom'
import "../../CampusViewMore/CampusViewMore.scss"
import CampusDynamicSection from "../../CampusSections/CampusDynamicSection/CampusDynamicSection";



const CampusPlacementCareerDynamicPage = ({data}) => {
    
               const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: <button className="slick-prev">❮</button>,
            nextArrow: <button className="slick-next">❯</button>,
            cssEase: "ease-in-out",
        
          
        
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: false
                }
              },
              {
                breakpoint: 889,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  initialSlide: 1
                }
              }
            ]
          };
           const [showContent, setShowContent] = useState(false)
        
  return (
    <>
    <div>
      
      <Header />
     
      <div className='campusmaincontainer'>
      <div className='campus-container'>
        <CampusSlashTitle slashTitle={data.title} />
        <CampusDynamicSection data={data}/>
         <div className='in-train-content-list'>
          <h2 className='in-train-list-title'>{data.listTitle}
          </h2>
          <ul className='in-train-list-container'>
            {
                data.listContent.map((item,index)=>(
                    <li>{item}{index === data.listContent.length-1 && data.viewmore && <span className='campus-viewmore'><Link onClick={() => setShowContent(!showContent)} >{showContent ? "View Less" : "View More"}</Link></span>}</li>
                ))
            }
          </ul>
        </div>
        {/* <div className='testimonial-container'>
          <h2 className='testimonial-title'>{data.testimonialTitle}</h2>
          <div className='testimonial-carousel'>
            <Slider {...settings}>
                { data.testimonialContent.map((item)=>(<>
                    <div className='testimonial-slide'>
                <div className='staff-container'>
                  <div>
                    <div className='staff-subcontainer'>
                    <div className='staff-image-container'><img src={item.img} className='staff-image'></img></div>
                      <div className='staff-content-container'>
                        <h3 className='staff-name'>{item.staffName}</h3>
                        <p className='staff-profess'>{item.staffProfess}</p>
                        <p className='staff-content'>{item.staffContent}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </>))
              
}
            </Slider>
          </div>
        </div> */}
        </div>
        <Footer />
        </div>
      </div>
    </>
  )
}

export default CampusPlacementCareerDynamicPage